<template>
  <v-card
    id="copy-event-modal"
    :style="'padding: 0;' + (hideBoxShadow ? ' box-shadow:none!important' : '')"
    :loading="isLoading"
    tile
  >
    <v-card-title
      v-if="!hideEventDescription"
      style="
        padding: 10px;
        min-height: 52px;
        text-transform: uppercase;
        overflow: hidden;
        white-space: nowrap;
        font-weight: 400;
      "
    >
      DUPLICAZIONE INTERVENTO
    </v-card-title>

    <v-card-text style="padding: 0">
      <v-card flat>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                v-model="dateRangeText"
                label="Date (da ~ a)"
                prepend-icon="mdi-calendar"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-date-picker full-width v-model="dates" range></v-date-picker>
              <p>* I giorni non lavorativi verranno esclusi automaticamente</p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>
<style scoped>
.mainPage[isMobile="true"]
  .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right)
  > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(
    .v-slide-group--has-affixes
  )
  .v-slide-group__prev {
  display: none !important;
}
</style>
<script>
import EventType from "../../settings/EventType";
import EasyPlanClient from "../../utils/EasyPlanClient";
import TabDatiEvento from "./Tabs/TabDatiEvento";
import TableRisorse from "./Tabs/TableRisorse";
import moment from "moment";
export default {
  props: {
    evento: { default: null },
    hideEventDescription: { default: false, type: Boolean },
    hideBoxShadow: { default: false, type: Boolean },
  },
  components: {
    TabDatiEvento,
    TableRisorse,
  },
  data: () => ({
    EventType: EventType,
    isMobile: false,
    dates: [],
    isLoading: false,
    activeTab: "k1",

    dateFrom: moment(new Date()).format("yyyy-MM-DD"),
    showDtpDateFrom: false,
  }),
  mounted() {
    this.loadEventData(this.event);
    this.setDefaultTab();
  },
  computed: {
    fullRangeDates() {
      let dates = this.dates;
      if (dates.length == 0)
        //Caso data non selezionata
        return [];
      if (dates.length == 1)
        //Caso data singola
        return [moment(dates[0])];
      else {
        //sistemo le date perchè sono in ordine di selezione e l'utente potrebbe aver selezionato prima quella di fine
        let minDate = dates[0];
        let maxDate = dates[1];
        if (moment(minDate).isAfter(moment(maxDate))) {
          minDate = dates[1];
          maxDate = dates[0];
        }

        let daysDiff = moment(maxDate).diff(moment(minDate), "days") + 1;
        console.debug("FullRangeDate daysDiff",daysDiff);
        let fullRangeDates = [];
        for (let i = 0; i < daysDiff; i++) {
          fullRangeDates.push(moment(minDate).add(i, "day"));
          console.debug("FullRangeDate fullRangeDates",fullRangeDates);
        }
        return fullRangeDates;
      }
    },
    dateRangeText() {
      let datesFormatted = [];
      let sorted = this.fullRangeDates;
      if (this.fullRangeDates.length > 2) {
        //prendo solo l'ultima e la prima che sono la data inizio e quella di fine
        let tmp = sorted;
        let minDate = sorted[0];
        let maxDate = sorted[this.fullRangeDates.length - 1];
        sorted = [minDate, maxDate];
      }
      
      for (var i = 0; i < sorted.length; i++) {
        let formatted = moment(sorted[i]).format("DD/MM/yyyy"); 
          datesFormatted.push(formatted); 
      }
      return datesFormatted.join(" ~ ");
    },
  },
  created() {
    this.checkIfIsMobile();
    // this.loadEvents();
  },
  methods: {
    getFormattedDate(date) {
      return moment(date).format("DD/MM/yyyy");
    },
    checkIfIsMobile() {
      this.isMobile = window.innerWidth < 600;
    },
    async loadEventData(event) {
      this.isLoading = true;
      if (event != undefined && event != null)
        if (this.evento.creatore == null) {
          let creator = await this.loadUser(event.idCreatore);
          this.evento.creatore = creator;
          this.refresh();
        }
      this.isLoading = false;
    },
    setDefaultTab() {
      this.activeTab = "k1";
    },

    refresh() {
      let ev = this.evento;
      this.evento = ev;
      this.dates=[];
    },
    async loadUser(userId) {
      let res = null;
      try {
        console.log("loading user", userId);
        res = await EasyPlanClient.User.Find(
          this.$route.params.companyAlias,
          userId
        );

        console.debug("user loaded", res);
        // callback(res.data.data);

        return res.data.data;
      } catch (error) {
        this.handleError(error);
      }
      return null;
    },
    handleError(error) {
      console.log(error);
      this.error = EasyPlanClient.GetErrorDescription(
        error.response.data.errorCode
      );
      console.error(
        "si è verificato un errore (" +
          error.response.data.errorCode +
          ")" +
          this.error
      );
    },
  },
  watch: {
    evento(value, old) {
      this.dates=[];
      this.dateFrom = moment(this.evento.inizio).format("yyyy-MM-dd");
      this.dateTo = moment(this.evento.inizio).format("yyyy-MM-dd");
    },
  },
  // methods: {
  //   loadEvents(eventId) {
  //     console.log("loading workers...");
  //     EasyPlanClient.Event.Find(this.$route.params.companyAlias,eventId)
  //       .then((res) => {
  //         this.event = res.data.data;
  //         console.log(this.events);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         this.error = EasyPlanClient.GetErrorDescription(
  //           error.response.data.errorCode
  //         );
  //         console.error(
  //           "si è verificato un errore (" +
  //             error.response.data.errorCode +
  //             ")" +
  //             this.error
  //         );
  //         console.error(error);
  //       });
  //   },
  // },
};
</script>

